import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ACCOUNT_FEATURE_KEY,
} from './account.reducer';
import {
  IAccountState,
  ISelfExcludeOrSuspend,
  ISelfExcludeOrSuspendVerification,
  IAccountPreferences,
  IStatements,
  IBetSummary,
  IOverview,
  IAccountDailyLossLimit
} from './account.models';

// Lookup the 'Account' feature state managed by NgRx
export const selectAccountState =
  createFeatureSelector<IAccountState>(ACCOUNT_FEATURE_KEY);

export const getAccountLoaded = createSelector(
  selectAccountState,
  (state: IAccountState) => state?.isLoaded
);

export const getAccountError = createSelector(
  selectAccountState,
  (state: IAccountState) => state?.error
);

export const getBalance = createSelector(
  selectAccountState,
  (state: IAccountState): number | undefined => state?.balance?.CurrentBalance
);


// account section
export const account = createSelector(
  selectAccountState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IAccountState): any | undefined => state?.account
);

export const isGetUserAccountSuccess = createSelector(
  account,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (account: any | undefined): any | undefined => account?.details
);

// eprotect information section
// export const eProtectInformation = createSelector(
//   selectAccountState,
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   (state: IAccountState): any | undefined => state?.account
// );

// export const isGetUserEprotectInformationSuccess = createSelector(
//   account,
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   (eProtectInformation: any | undefined): any | undefined => account?.eProtectInformation
// );

export const getAccountStatements = createSelector(
  selectAccountState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IAccountState): IStatements | undefined => state?.statements
);

export const getBetSummary = createSelector(
  selectAccountState,
  (state: IAccountState): IBetSummary | undefined => state?.betSummary
);

export const getOverview = createSelector(
  selectAccountState,
  (state: IAccountState): IOverview | undefined => state?.overview
);

// responsible gaming section
export const selfExcludeOrSuspend = createSelector(
  selectAccountState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IAccountState): any | undefined => state?.selfExcludeOrSuspend
);

export const isSelfExcludeOrSuspendSuccess = createSelector(
  selfExcludeOrSuspend,
  (selfExcludeOrSuspend: ISelfExcludeOrSuspend | undefined):
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  {response: any, isSuccess: boolean | undefined, isProcessing: boolean | undefined} => ({
    response: selfExcludeOrSuspend?.response,
    isSuccess: selfExcludeOrSuspend?.isSuccess,
    isProcessing: selfExcludeOrSuspend?.isProcessing
  })
);

export const selfExcludeOrSuspendVerification = createSelector(
  selectAccountState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IAccountState): any | undefined => state?.selfExcludeOrSuspendVerification
);

export const isSelfExcludeOrSuspendVerificationSuccess = createSelector(
  selfExcludeOrSuspendVerification,
  (selfExcludeOrSuspendVerification: ISelfExcludeOrSuspendVerification | undefined):
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  {response: any, isSuccess: boolean | undefined, isProcessing: boolean | undefined} => ({
    response: selfExcludeOrSuspendVerification?.response,
    isSuccess: selfExcludeOrSuspendVerification?.isSuccess,
    isProcessing: selfExcludeOrSuspendVerification?.isProcessing
  })
);

// wagering preferences
export const isGetAccountPreferencesSuccess = createSelector(
  selectAccountState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IAccountState): IAccountPreferences | undefined => state?.configuration
);

export const isUpsertAccountPrefenceFieldSuccess = createSelector(
  selectAccountState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IAccountState): any | undefined => state?.updateAccountPreferences
);

export const getPreferenceFavorites = createSelector(
  selectAccountState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IAccountState): string[] | undefined =>
    state?.configuration?.response?.AccountPreferences?.ListOfFavorites
);

// wagering limits
export const isGetAccountDailyLossLimitSuccess = createSelector(
  selectAccountState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IAccountState): IAccountDailyLossLimit | undefined => state?.lossLimit
);

export const isUpdateAccountDailyLossLimitSuccess = createSelector(
  selectAccountState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IAccountState): any | undefined => state?.lossLimit
);

export const getPromoList = createSelector(
  selectAccountState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IAccountState): any | undefined => state?.promos
);

export const useGiveAway = createSelector(
  selectAccountState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IAccountState): any | undefined => state?.useGiveAway
);

export const usePromo = createSelector(
  selectAccountState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: IAccountState): any | undefined => state?.usePromo
);
